import type { TupleToUnion } from 'type-fest'

const themeTextColorNames = [
  'brand',
  'primary',
  'primary-inverse',
  'secondary',
  'secondary-inverse',
  'tertiary',
  'disabled',
  'disabled-inverse',
  'info',
  'link',
  'link-hover',
  'link-pressed',
  'link-subtle',
  'positive',
  'caution',
  'negative',
  'notice',
  'current',
] as const

type ThemeTextColor = TupleToUnion<typeof themeTextColorNames>

const themeTextColorMap: Record<ThemeTextColor, string> = {
  brand: 'text-brand',
  primary: 'text-primary',
  'primary-inverse': 'text-primary-inverse',
  secondary: 'text-secondary',
  'secondary-inverse': 'text-secondary-inverse',
  tertiary: 'text-tertiary',
  disabled: 'text-disabled',
  'disabled-inverse': 'text-disabled-inverse',
  link: 'text-link',
  'link-hover': 'text-link-hover',
  'link-pressed': 'text-link-pressed',
  'link-subtle': 'text-link-subtle',
  info: 'text-info',
  positive: 'text-positive',
  caution: 'text-caution',
  negative: 'text-negative',
  notice: 'text-notice',
  current: 'text-current',
}

const themeHoverTextColorNames = ['cta', 'primary', 'negative'] as const
type ThemeHoverTextColor = TupleToUnion<typeof themeHoverTextColorNames>

const themeHoverTextColorMap: Record<ThemeHoverTextColor, string> = {
  cta: 'hover:text-blue-200',
  primary: 'hover:text-white/90',
  negative: 'hover:text-primary-red',
}

const themeActiveTextColorNames = ['primary', 'negative'] as const
type ThemeActiveTextColor = TupleToUnion<typeof themeActiveTextColorNames>

const themeActiveTextColorMap: Record<ThemeActiveTextColor, string> = {
  primary: 'active:text-white/90',
  negative: 'active:text-primary-red',
}

const themeDisabledTextColorNames = ['primary', 'inverse', 'negative'] as const
type ThemeDisabledTextColor = TupleToUnion<typeof themeDisabledTextColorNames>

const themeDisabledTextColorMap: Record<ThemeDisabledTextColor, string> = {
  primary: 'disabled:text-white/20 data-[disabled]:text-white/20',
  inverse: 'disabled:text-black/20 data-[disabled]:text-black/20',
  negative: 'disabled:text-primary-red data-[disabled]:text-primary-red',
}

const themePlaceholderTextColorNames = ['primary'] as const
type ThemePlaceholderTextColor = TupleToUnion<
  typeof themePlaceholderTextColorNames
>

const themePlaceholderTextColorMap: Record<ThemePlaceholderTextColor, string> =
  {
    primary: 'placeholder:text-white/40',
  }

export {
  type ThemeActiveTextColor,
  type ThemeDisabledTextColor,
  type ThemeHoverTextColor,
  type ThemePlaceholderTextColor,
  type ThemeTextColor,
  themeActiveTextColorMap,
  themeDisabledTextColorMap,
  themeHoverTextColorMap,
  themePlaceholderTextColorMap,
  themeTextColorMap,
  themeTextColorNames,
}
